import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DisplayOnlyField from './fields/DisplayOnlyField';
import HistoryTooltip from './fields/HistoryTooltip';

export default function MuiSelect({
  label,
  wrapperClasses,
  options,
  value,
  onChange,
  multiple,
  emptyLabel,
  size,
  disabled,
  sort = true,
  displayOnly,
  format = { value: 'value', label: 'label' },
  defaultFormat,
  marginRight,
  withHistory,
  history = [],
}) {
  // console.log("🚀 ~ value:", value)
  if (defaultFormat) format = { value: 'id', label: 'name' };
  if (!sort) {
    options = options;
  } else {
    options = options?.sort((a, b) => (a[format?.label] > b[format?.label] ? 1 : -1));
  }

  const resolveLabel = (val) =>
    options?.find((o) => o?.[format?.value] === val)?.[format?.label] ?? val ?? '';
  const displayText = multiple
    ? (value || [])
        .map((v) => resolveLabel(v))
        .filter(Boolean)
        .join(', ')
    : resolveLabel(value);

  if (displayOnly || disabled) {
    return (
      <div className="flex items-center gap-2 w-full">
        <div className={`${wrapperClasses} flex-1`}>
          <DisplayOnlyField label={label} value={displayText} />
        </div>
        <HistoryTooltip show={withHistory} history={history} />
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2 flex-1">
      <Box
        sx={{ minWidth: 150, marginRight: marginRight, flex: 1 }}
        className={wrapperClasses + ' shadow-sm'}
      >
        <FormControl size={size || 'medium'} fullWidth>
          <InputLabel
            // sx={{ color: 'green' }}
            id={`label`}
          >
            {label}
          </InputLabel>

          <Select
            readOnly={disabled}
            // disabled={disabled}
            sx={{ color: 'green' }}
            labelId={`${label}-label`}
            id={label}
            value={value}
            label={label}
            onChange={onChange}
            multiple={multiple}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                  zIndex: 9999,
                },
              },
              style: {
                zIndex: 9999,
              },
            }}
            // defaultValue={value}
            // variant='standard'
          >
            {emptyLabel && <MenuItem>--- {emptyLabel} ---</MenuItem>}
            {options &&
              options?.map((option) => (
                <MenuItem key={option[format?.value]} value={option[format?.value]}>
                  {option[format?.label]}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
      <HistoryTooltip show={withHistory} history={history} />
    </div>
  );
}
